// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.acessedFolder[data-v-05d10674] {\n  font-weight: bold;\n}\n.folderName[data-v-05d10674] {\n  cursor: pointer;\n}\n.folderName[data-v-05d10674]:hover {\n  text-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
